module.exports = __webpack_public_path__ + "static/media/light.660c1435.jpg";